var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { css } from '@emotion/react';
import { darkThemeStyle, theme } from '../theme';
import { tokens } from '../tokens';
var wrapperStaticStyle = css({
    position: 'relative',
    width: '100%',
});
export function wrapperStyle(_a) {
    var inverted = _a.inverted;
    return __spreadArray(__spreadArray([], __read((inverted ? [darkThemeStyle] : [])), false), [wrapperStaticStyle], false);
}
export var labelStaticStyle = css({
    color: theme.text.main,
    display: 'flex',
    fontWeight: tokens.fontWeights.bold,
    lineHeight: tokens.lineHeights.default,
    marginBottom: tokens.spacing.small,
});
export var descriptionStaticStyle = css({
    lineHeight: tokens.lineHeights.default,
    marginTop: "-".concat(tokens.spacing.xsmall),
});
var requiredIndicatorStaticStyle = css({
    alignItems: 'center',
    color: theme.text.subtle,
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'end',
    textAlign: 'right',
    userSelect: 'none',
});
export function requiredIndicatorStyle(_a) {
    var size = _a.size;
    return [
        requiredIndicatorStaticStyle,
        css({
            fontSize: size === 'small' ? tokens.fontSizes.xsmall : tokens.fontSizes.small,
        }),
    ];
}
var requiredDotStaticStyle = css({
    backgroundColor: theme.red.darker,
    borderRadius: tokens.borderRadius.circle,
    display: 'inline-block',
    flexShrink: 0,
    marginRight: tokens.spacing.xsmall,
});
export function requiredDotStyle(_a) {
    var size = _a.size;
    return [
        requiredDotStaticStyle,
        css({
            height: size === 'small' ? 4 : 6,
            width: size === 'small' ? 4 : 6,
        }),
    ];
}
export var errorStaticStyle = css({
    color: theme.error.text,
    lineHeight: tokens.lineHeights.default,
    marginTop: tokens.spacing.small,
});
